import React, {Component} from 'react';
import Pager from "../../../controls/Pager";
import BackEnd from "../../../backend/BackEnd";
import Moment from "react-moment";

class Performance extends Component {
    static propTypes = {};
    static defaultProps = {
        pageSize: 15
    };
    state = {
        isLoading: false,
        filters: {},
        facetFilters: {},
        pageIndex: 0,
        items: [],
        totalCount: 0
    };
    searchWebApiRecords = new BackEnd.Performance.SearchWebApiRecords(this);

    async componentDidMount() {
        await this.fetchTableData();
    }

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                <i className="px-nav-icon ion-cube"/> Для разработчиков /
                                </span> Метрики производительности
                            </h1>
                        </div>
                    </div>
                </div>
                <div className="panel">
                    <div className="panel-heading">
                        <span className="panel-title">&nbsp;</span>
                        <div className="panel-heading-controls">
                            <Pager pageSize={this.props.pageSize}
                                   pageIndex={this.state.pageIndex}
                                   totalCount={this.state.totalCount}
                                   onChange={pageIndex => this.updatePageIndex(pageIndex)}/>
                        </div>
                    </div>
                    <div className="panel-body">
                        <table className={`table table-striped ${this.state.isLoading ? 'form-loading' : ''}`}>
                            <thead>
                            <tr>
                                <th>Метод</th>
                                <th>Контроллер.Экшен</th>
                                <th>Сред. время, мс</th>
                                <th>Мин. время, мс</th>
                                <th>Макс. время, мс</th>
                                <th>Кол-во вызовов</th>
                                <th>Дата и время последнего вызова</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(item =>
                                <tr key={item.id}>
                                    <td>{item.method}</td>
                                    <td>{item.controllerName}.{item.actionName}</td>
                                    <td>
                                        <strong>{item.avgTime}</strong>
                                    </td>
                                    <td>{item.minTime}</td>
                                    <td>{item.maxTime}</td>
                                    <td>{item.hitCount}</td>
                                    <td>
                                        <Moment format="DD.MM.YYYY HH:mm:ss">{item.lastTimestamp}</Moment>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    updatePageIndex(pageIndex) {
        this.setState({pageIndex},
            () => this.fetchTableData());
    }

    async fetchTableData() {
        let result = await this.searchWebApiRecords.call({
            dto: {
                paging: {
                    pageIndex: this.state.pageIndex,
                    pageSize: this.props.pageSize
                }
            }
        });

        this.setState({...result});
    }
}

export default Performance;


// WEBPACK FOOTER //
// ./src/pages/Developers/Performance/Performance.js